import type { TFunction } from "i18next";

/** Localized shipment status label (draft/ready/shipped/delivered), falling back
 * to the raw value if no translation key exists. */
export function shipmentStatusLabel(t: TFunction, status: string | null | undefined): string {
  if (!status) return "";
  return t(`shipments.status.${status}`, { defaultValue: status });
}

/** Localized delivery-type label. Built-in types (slug set: normal/debt/defect_exchange)
 * are translated; user-managed custom types (no slug) show their stored name. */
export function deliveryTypeLabel(
  t: TFunction,
  slug: string | null | undefined,
  name: string | null | undefined,
): string {
  if (slug) return t(`shipments.deliveryTypeNames.${slug}`, { defaultValue: name ?? slug });
  return name ?? "";
}
